<template>
  <b-card>
    <div>
      <b-row>
        <b-col md="9">
          <div class="custom-search align-items-center">
            <div
              class="d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
            >
              <b-form-input
                v-on:keyup="onSearch"
                v-model.lazy="searchTerm"
                placeholder="Search..."
                type="text"
                class="d-inline-block mr-sm-1 mb-1 mb-sm-0"
              />
            </div>
          </div>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <flat-pickr
              v-model="rangeDate"
              class="form-control"
              placeholder="Date Filter"
              :config="{ mode: 'range' }"
            />
          </b-form-group>
        </b-col>
        <b-col md="1">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="clearFilter"
          >
            Clear
          </b-button>
        </b-col>  
      </b-row>
      <template>
        <b-row>
          <b-col md="1">
            <div>
              <b-badge variant="light-primary" style="font-size: xx-large">
                {{ statusCount }}
              </b-badge>
            </div>
          </b-col>

          <template v-if="isRowChecked && $permissionAbility(ORDERS_STATUS_CHANGE, permissions)">
            <b-col md="1">
              <b-dropdown
                id="dropdown-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                text="Action"
                variant="primary"
              >
                <b-dropdown-item @click="printSelectedSticker()"
                  >Print Sticker</b-dropdown-item
                >
                <b-dropdown-divider></b-dropdown-divider>
                
                <b-dropdown-item value="pending" @click="handleStatusClick('pending')">Mark as Pending</b-dropdown-item>
                <b-dropdown-item value="pending-1" @click="handleStatusClick('pending-1')">Mark as Pending 1</b-dropdown-item>
                <b-dropdown-item value="pending-2" @click="handleStatusClick('pending-2')">Mark as Pending 2</b-dropdown-item>
                <b-dropdown-item value="processing" @click="handleStatusClick('processing')">Mark as Processing</b-dropdown-item>
                <b-dropdown-item value="hold" @click="handleStatusClick('hold')">Mark as Hold</b-dropdown-item>
                <b-dropdown-item value="in_review" @click="handleStatusClick('in_review')">Mark as In Review</b-dropdown-item>
                <b-dropdown-item value="packing" @click="handleStatusClick('packing')">Mark as Packing</b-dropdown-item>
                <b-dropdown-item value="shipping" @click="handleStatusClick('shipping')">Mark as Shipping</b-dropdown-item>
                <b-dropdown-item value="verified" @click="handleStatusClick('verified')">Mark as Verified</b-dropdown-item>
                <b-dropdown-item value="on_the_way" @click="handleStatusClick('on_the_way')">Mark as On the way</b-dropdown-item>
                <b-dropdown-item value="returned" @click="handleStatusClick('returned')">Mark as Return</b-dropdown-item>
                <b-dropdown-item value="return_received" @click="handleStatusClick('return_received')">Mark as Return Received</b-dropdown-item>
                <b-dropdown-item value="canceled" @click="handleStatusClick('canceled')">Mark as Cancel</b-dropdown-item>
                <b-dropdown-item value="delivered" @click="handleStatusClick('delivered')">Mark as Delivery</b-dropdown-item>

                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item value="rejected" @click="handleStatusClick('rejected')">Mark as Rejected</b-dropdown-item>
              </b-dropdown>
            </b-col>
          </template>

          <b-col md="10">
            <div style="overflow-x: auto; white-space: nowrap; max-width: 100%">
              <b-form-group>
                <b-form-radio-group
                  id="btn-radios-1"
                  v-model="filterStatus"
                  button-variant="outline-primary"
                  :options="optionsRadio"
                  buttons
                  name="radios-btn-default"
                />
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </template>

      <div style="max-height: 600px; overflow-y: auto;">
        <vue-good-table
        :line-numbers="true"
        mode="remote"
        @on-selected-rows-change="selectionChanged"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :isLoading="isLoading"
        :rows="rows"
        :sort-options="{
          enabled: true,
          multipleColumns: true,
          initialSortBy: [
            { field: 'id', type: 'desc' },
            { field: 'name', type: 'desc' },
            { field: 'created_at', type: 'desc' },
          ],
        }"
        :columns="columns"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true, 
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: false, 
          selectAllByGroup: true, 
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'format_order'">
            
            <div style="display: block">
              <template v-if="$permissionAbility(ORDERS_SHOW, permissions)">
                <b-link v-on:click="showModal(props.row.id)">
                  <span v-if="props.row.is_sticker_printed == 'yes'" style="font-size: small;">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" style="margin-bottom: 5px;" viewBox="0 0 48 48">
                      <path fill="#43A047" d="M40.6 12.1L17 35.7 7.4 26.1 4.6 29 17 41.3 43.4 14.9z"></path>
                    </svg>
                  </span> 
                  <strong>ID: </strong>  
                  <span>{{ props.row.large_order_id }}</span> 
                  <span v-if="props.row.comment" style="color: red;">*</span>
                </b-link>
              </template>

              <template v-else>
                  <span v-if="props.row.is_sticker_printed == 'yes'" style="font-size: small;">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" style="margin-bottom: 5px;" viewBox="0 0 48 48">
                      <path fill="#43A047" d="M40.6 12.1L17 35.7 7.4 26.1 4.6 29 17 41.3 43.4 14.9z"></path>
                    </svg>
                  </span> 
                  <strong>ID: </strong>  
                  <span>{{ props.row.large_order_id }}</span> 
                  <span v-if="props.row.comment" style="color: red;">*</span>
              </template>
              
            </div>

            <div style="display: block" class="mt-1">
              <strong>Tk: </strong>
              
              <template v-if="isEditing(props.row.id, 'total_price')">
                  <div class="d-flex">
                      <b-form-input size="sm" v-model="editValue" style="width: 80px" />
                      <feather-icon icon="CheckIcon" class="text-success cursor-pointer ml-1" @click="saveEdit(props.row)"/>
                      <feather-icon icon="XIcon" class="text-danger cursor-pointer ml-1" @click="cancelEdit()"/>
                  </div>
              </template>
              <template v-else>
                  <span>{{ props.row.total_price }}</span>
                  <feather-icon icon="Edit2Icon" size="12" class="text-primary cursor-pointer ml-1" @click="enableEdit(props.row, 'total_price', props.row.total_price)"/>
              </template>

            </div>
          </span>
          
          <span v-if="props.column.field === 'format_customer'">
            <div style="display: block">
                <strong>Name: </strong>  
                <template v-if="isEditing(props.row.id, 'customer_name')">
                  <div class="d-flex">
                      <b-form-input size="sm" v-model="editValue" style="width: 120px" />
                      <feather-icon icon="CheckIcon" class="text-success cursor-pointer ml-1" @click="saveEdit(props.row)"/>
                      <feather-icon icon="XIcon" class="text-danger cursor-pointer ml-1" @click="cancelEdit()"/>
                  </div>
                </template>
                <template v-else>
                    <span>{{ props.row.customer.first_name }}</span> 
                    <feather-icon icon="Edit2Icon" size="12" class="text-primary cursor-pointer ml-1" @click="enableEdit(props.row, 'customer_name', props.row.customer.first_name)"/>
                    <span v-if="props.row.comment" style="color: red;">*</span>
                </template>
            </div>
            
            <div style="display: block" class="mt-1">
               <strong>Phone: </strong>
               <template v-if="isEditing(props.row.id, 'customer_phone')">
                  <div class="d-flex">
                      <b-form-input size="sm" v-model="editValue" style="width: 120px" />
                      <feather-icon icon="CheckIcon" class="text-success cursor-pointer ml-1" @click="saveEdit(props.row)"/>
                      <feather-icon icon="XIcon" class="text-danger cursor-pointer ml-1" @click="cancelEdit()"/>
                  </div>
                </template>
                <template v-else>
                   <b-badge variant="light-success">
                     {{ props.row.customer.phone }}
                   </b-badge>
                   <feather-icon icon="Edit2Icon" size="12" class="text-primary cursor-pointer ml-1" @click="enableEdit(props.row, 'customer_phone', props.row.customer.phone)"/>
                   <span v-if="props.row.comment" style="color: red;">*</span>
                </template>
            </div>
            
            <div class="d-flex align-items-center mt-1">
                <b-button variant="outline-primary" size="sm" class="btn-icon rounded-circle mr-1" :href="'tel:' + props.row.customer.phone" title="Call Now">
                    <feather-icon icon="PhoneIcon" size="14"/>
                </b-button>
                <b-button variant="outline-success" size="sm" class="btn-icon rounded-circle mr-1" :href="getWhatsappLink(props.row.customer.phone)" target="_blank" title="Open WhatsApp">
                    <feather-icon icon="MessageCircleIcon" size="14"/>
                </b-button>
                <b-button variant="outline-secondary" size="sm" class="btn-icon rounded-circle" @click="copyToClipboard(props.row.customer.phone)" title="Copy Number">
                    <feather-icon icon="CopyIcon" size="14"/>
                </b-button>
            </div>
          </span>

          <span v-if="props.column.field === 'format_status'">
            <div>
                <b-badge :variant="statusVariant(props.row.status)">
                  {{ statusFormat(props.row.status) }}
                </b-badge>
            </div>
            
            <div v-if="props.row.status === 'rejected' && props.row.rejection_reason" class="mt-1">
                <small class="text-danger font-weight-bold">Reason: {{ props.row.rejection_reason }}</small>
            </div>

            <div v-if="props.row.status_updated_by" class="mt-1 text-muted" style="font-size: 10px; line-height: 1.2;">
                <div><feather-icon icon="UserIcon" size="10"/> {{ props.row.status_updated_by }}</div>
                <div v-if="props.row.status_updated_at">
                    <feather-icon icon="ClockIcon" size="10"/> {{ formatFnTableLastContactDate(props.row.status_updated_at) }}
                </div>
            </div>
          </span>

          <span v-if="props.column.field === 'format_payment_method'">
            <template v-if="props.row.payment_method == 'cash_on_delivery'">
              <b-badge variant="light-primary"> COD </b-badge>
            </template>
          </span>

          <span v-if="props.column.field === 'format_delivery_charge'">
            
            <div style="display: block">
                <span>Product Price: </span>
                <template v-if="isEditing(props.row.id, 'product_price')">
                  <div class="d-flex">
                      <b-form-input size="sm" v-model="editValue" style="width: 80px" />
                      <feather-icon icon="CheckIcon" class="text-success cursor-pointer ml-1" @click="saveEdit(props.row)"/>
                      <feather-icon icon="XIcon" class="text-danger cursor-pointer ml-1" @click="cancelEdit()"/>
                  </div>
                </template>
                <template v-else>
                    <span>{{ props.row.total_price - props.row.delivery_charge }}Tk</span>
                    <feather-icon icon="Edit2Icon" size="12" class="text-primary cursor-pointer ml-1" @click="enableEdit(props.row, 'product_price', (props.row.total_price - props.row.delivery_charge))"/>
                </template>
            </div>

            <div style="display: block">
              <span
                ><strong>{{ props.row.order_from }}</strong></span
              >
            </div>

            <div style="display: block">
                <span>Charge: </span>
                <template v-if="isEditing(props.row.id, 'delivery_charge')">
                  <div class="d-flex">
                      <b-form-input size="sm" v-model="editValue" style="width: 80px" />
                      <feather-icon icon="CheckIcon" class="text-success cursor-pointer ml-1" @click="saveEdit(props.row)"/>
                      <feather-icon icon="XIcon" class="text-danger cursor-pointer ml-1" @click="cancelEdit()"/>
                  </div>
                </template>
                <template v-else>
                    <span>{{ props.row.delivery_charge }}Tk</span>
                    <feather-icon icon="Edit2Icon" size="12" class="text-primary cursor-pointer ml-1" @click="enableEdit(props.row, 'delivery_charge', props.row.delivery_charge)"/>
                </template>
            </div>
          </span>

          <span v-if="props.column.field === 'detail_address'">
             <template v-if="isEditing(props.row.id, 'detail_address')">
                  <div class="d-flex">
                      <b-form-textarea size="sm" v-model="editValue" rows="3" />
                      <div class="d-flex flex-column ml-1">
                          <feather-icon icon="CheckIcon" class="text-success cursor-pointer mb-1" @click="saveEdit(props.row)"/>
                          <feather-icon icon="XIcon" class="text-danger cursor-pointer" @click="cancelEdit()"/>
                      </div>
                  </div>
              </template>
              <template v-else>
                <div class="d-flex align-items-start">
                    <span>{{ props.row.detail_address }}</span>
                    <div style="min-width: 40px; margin-left: 5px;">
                        <feather-icon icon="Edit2Icon" size="16" class="text-primary cursor-pointer" @click="enableEdit(props.row, 'detail_address', props.row.detail_address)" v-b-tooltip.hover title="Edit Address"/>
                        <feather-icon icon="CopyIcon" size="16" class="text-secondary cursor-pointer ml-1" @click="copyToClipboard(props.row.detail_address)" v-b-tooltip.hover title="Copy Address"/>
                    </div>
                </div>
              </template>
          </span>

          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                border-radius
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <template>
                  <b-dropdown-item v-if="$permissionAbility(ORDERS_SHOW, permissions)" v-on:click="onView(props.row.id)">
                    <feather-icon icon="EyeIcon" class="mr-50" />
                    <span>View</span>
                  </b-dropdown-item>
                  <b-dropdown-item v-if="$permissionAbility(ORDERS_SHOW, permissions)" v-on:click="showModal(props.row.id)">
                    <feather-icon icon="EyeIcon" class="mr-50" />
                    <span>View Here</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="showOrderCommentModal(props.row.id)"
                  >
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>Followup</span>
                  </b-dropdown-item>
                </template>
              </b-dropdown>
            </span>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['10', '20', '50', '100', '200', '300', '500', '1000', '2000', '3000', '5000', '7000', '10000', '13000', '15000', '17000', '20000']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
               <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
      </div>
      
    </div>

    <b-modal
      id="modal-rejection-reason"
      centered
      title="Rejection Reason"
      ok-title="Save & Reject"
      cancel-title="Cancel"
      @ok="confirmRejection"
      @hidden="resetRejectionModal"
    >
        <b-form-group label="Why is this order being rejected?" label-for="reject-reason">
            <b-form-textarea
                id="reject-reason"
                v-model="rejectionReason"
                placeholder="Enter reason (e.g. Customer canceled, Fake order)"
                rows="3"
            ></b-form-textarea>
        </b-form-group>
    </b-modal>

    <b-modal
      id="modal-order-details"
      centered
      size="xl"
      title="Order Details"
      hide-footer
      @hidden="hiddenModal"
      no-close-on-backdrop
    >
      <b-row>
        <b-col md="2" lg="2" xs="2">
          <h3 v-if="modalOrderId">Order Id: {{ modalOrderId }}</h3>
        </b-col>
        <b-col md="10" lg="10" xs="10">
          <h4 class="text-capitalize">
            Status:
            <b-badge variant="light-primary" style="font-size: large">
              {{ statusFormat(modalOrderStatus) }}
            </b-badge>
          </h4>
        </b-col>
      </b-row>
      
      <hr>
<template v-if="modalCustomerId">
  <customer-all-order-status-vue
  :customerId = "modalCustomerId"
  ></customer-all-order-status-vue>
</template>
        
      <hr>
      
      <b-row>
        <b-col md="2" lg="2" xs="2">
          <h5 class="text-capitalize">Customer</h5>
          <template>
            <div>
              <b-card-text>
                <strong>
                  <b-link v-on:click="onViewCustomer(modalCustomerId)">
                    {{ modalCustomerName }} 
                  </b-link>

                  <b-badge v-if="modalCustomerStatus" variant="light-danger">
                    Banned
                  </b-badge>
                  <b-badge v-else variant="light-success">
                    Active
                  </b-badge>
                </strong>
              </b-card-text>
            </div>

            <div>
              <b-card-text>{{ modalCustomerPhone }}</b-card-text>
            </div>

            <div>
              <b-card-text>{{ modalCustomerAddress }}</b-card-text>
            </div>
          </template>

          <template v-if="$permissionAbility(CUSTOMERS_BLOCK, permissions)">
            <br>
          <h5 class="text-capitalize">Customer Status Change</h5>
            <div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="bandActiveCustomer"
              >
                <template v-if="modalCustomerStatus">
                  Active
                </template>
                <template v-else>
                  Banned
                </template>
              </b-button>
            </div>
          </template>
        </b-col>

        



        <b-col md="8" lg="8" xs="8">
          <b-row v-for="(item, index) in modalProducts" :key="index">
            <b-col md="3" lg="3" xs="3">
              <h5 class="text-capitalize">Product name</h5>
              <template>
                <div>
                  <b-card-text>{{ item.name }}</b-card-text>
                </div>
              </template>
            </b-col>

            <b-col md="2" lg="2" xs="2">
              <h5 class="text-capitalize">SKU</h5>
              <template>
                <div>
                  <b-card-text>{{ getOrderItemSku(item) }}</b-card-text>
                </div>
              </template>
            </b-col>

            <b-col md="2" lg="2" xs="2">
              <h5 class="text-capitalize">Quantity</h5>
              <template>
                <div>
                  <b-card-text>{{ item.pivot.quantity }}</b-card-text>
                </div>
              </template>
            </b-col>

            <b-col md="3" lg="3" xs="3">
              <h5 class="text-capitalize">Attributes</h5>
              <template>
                <div v-if="getOrderItemAttributes(item).length">
                  <b-badge
                    v-for="(attr, attrIndex) in getOrderItemAttributes(item)"
                    :key="`${index}-${attrIndex}`"
                    variant="light-primary"
                    class="mr-50 mb-50"
                  >
                    {{ attr.name }}: {{ attr.value }}
                  </b-badge>
                </div>
                <div v-else>
                  <b-card-text class="text-muted">N/A</b-card-text>
                </div>
              </template>
            </b-col>

            <b-col md="2" lg="2" xs="2">
              <h5 class="text-capitalize">Image</h5>
              <div class="image-container">
                <img
                  class="small-image"
                  :src="item.small_pictures[0].original_url"
                />
                <div
                  class="large-image"
                  :style="{
                    backgroundImage:
                      'url(' + item.small_pictures[0].original_url + ')',
                  }"
                ></div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="order-comment-modal"
      centered
      size="lg"
      title="Followup"
      hide-footer
      @hidden="hiddenOrderCommentModal"
      no-close-on-backdrop
    >
    <div class="scrollable">

   
        <b-col md="12" lg="12" xs="12" v-for="followUpMsg in followUpMsgs" :key="followUpMsg.id" >
            <h5 class="text-capitalize" v-if="$permissionAbility(ORDERS_FOLLOW_UP_NAME_SHOW, permissions)" >{{ followUpMsg.user.name }}</h5>
            <div>
              <b-card-text>{{ followUpMsg.msg }}</b-card-text>
            </div>
            <h6 class="text-capitalize">{{ formatFnTableLastContactDate(followUpMsg.created_at) }}</h6>
            <hr>
        </b-col>
        
        <br><br><br>

      <b-row>
        <b-col md="12" lg="12" xs="12">
          <b-form-textarea
            id="address"
            type="text"
            v-model="followupComment"
            placeholder="Followup"
            rows="3"
          />
        </b-col>

        <b-col cols="12" style="margin-top: 10px;">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="submitFollowupComment"
              >
                Submit
              </b-button>
        </b-col>
      </b-row>

    </div>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BRow,
  BFormRadioGroup,
  BCardText,
  BLink,
  BFormTextarea,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'

import {
  ORDERS_FOLLOW_UP_NAME_SHOW,
  ORDERS_SHOW,
  ORDERS_STATUS_CHANGE,
  CUSTOMERS_BLOCK,
} from '@/helpers/permissionsConstant'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import CustomerAllOrderStatusVue from '@/views/admin/customer/CustomerAllOrderStatus.vue'

export default {
  mixins: [togglePasswordVisibility],
  name: 'OrderView',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BFormRadioGroup,
    flatPickr,
    BCardText,
    BLink,
    BFormTextarea,
    CustomerAllOrderStatusVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      ORDERS_FOLLOW_UP_NAME_SHOW,
      ORDERS_SHOW,
      ORDERS_STATUS_CHANGE,
      CUSTOMERS_BLOCK,

      userId: '',
      name: '',
      statusCount: '',
      rangeDate: null,
      isRowChecked: false,
      selectedRows: [],

      editingId: null,
      editingField: null,
      editValue: '',
      
      rejectionReason: '',

      modalOrderId: '',
      modalCustomerName: '',
      modalOrderStatus: '',
      modalCustomerStatus: '',

      modalCustomerPhone: '',
      modalCustomerAddress: '',
      modalProducts: [],
      modalCustomerId: '',
      followupComment: '',
      commentModalOrderId: '',

      followUpMsgs: [],

      filterStatus: 'pending',
      // UPDATED OPTIONS RADIO WITH YOUR REQUESTED ORDER
      optionsRadio: [
        { text: 'All', value: 'all' },
        { text: 'Pending', value: 'pending' },
        { text: 'Pending 1', value: 'pending-1' },
        { text: 'Pending 2', value: 'pending-2' },
        { text: 'Processing', value: 'processing' },
        { text: 'Hold', value: 'hold' },
        { text: 'In Review', value: 'in_review' },
        { text: 'Packing', value: 'packing' },
        { text: 'Shipping', value: 'shipping' },
        { text: 'Verified', value: 'verified' },
        { text: 'On the way', value: 'on_the_way' },
        { text: 'Return', value: 'returned' },
        { text: 'Return Received', value: 'return_received' },
        { text: 'Cancel', value: 'canceled' },
        { text: 'Delivery', value: 'delivered' },
        { text: 'Rejected', value: 'rejected' },
      ],

      pageLength: 10,
      columns: [
        { label: 'Order', field: 'format_order', sortable: false },
        { label: 'Status', field: 'format_status', sortable: false },
        { label: 'Updated', field: 'updated_at', formatFn: this.formatFnTableLastContactDate },
        { label: 'Delivery', field: 'format_delivery_charge', sortable: false },
        { label: 'Customer', field: 'format_customer', sortable: false },
        { label: 'Detail Address', field: 'detail_address', sortable: false },
        { label: 'Payment Method', field: 'format_payment_method', sortable: false },
        { label: 'Created At', field: 'created_at', formatFn: this.formatFnTableLastContactDate, sortable: false },
        { label: 'Action', field: 'action', sortable: false },
      ],
      rows: [],
      searchTerm: '',
      delayTimer: null,
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          { field: 'id', type: 'desc' },
        ],
        page: 1,
        perPage: 10,
      },
    }
  },

  computed: {
    ...mapGetters({
      permissions: 'userModule/getPermissions',
    }),
  },

  watch: {
    filterStatus: function () {
      this.loadItems()
    },
    rangeDate: function () {
      this.loadItems()
    },
  },

  methods: {
    handleStatusClick(status) {
        if (status === 'rejected') {
            this.$bvModal.show('modal-rejection-reason');
        } else {
            this.changeSelectedStatus(status);
        }
    },
    confirmRejection(bvModalEvt) {
        if (!this.rejectionReason) {
             bvModalEvt.preventDefault()
             this.$toast({
                component: ToastificationContent,
                props: { title: 'Warning', icon: 'AlertCircleIcon', variant: 'warning', text: 'Please enter reason' },
            });
            return;
        }
        this.changeSelectedStatus('rejected', this.rejectionReason);
    },
    resetRejectionModal() {
        this.rejectionReason = '';
    },

    isEditing(rowId, field) {
        return this.editingId === rowId && this.editingField === field;
    },
    enableEdit(row, field, value) {
        this.editingId = row.id;
        this.editingField = field;
        this.editValue = value;
    },
    cancelEdit() {
        this.editingId = null;
        this.editingField = null;
        this.editValue = '';
    },
    async saveEdit(row) {
        try {
            await this.$api.post('api/orders/inline-update', { id: row.id, field: this.editingField, value: this.editValue });
            this.$toast({ component: ToastificationContent, props: { title: 'Success', icon: 'CheckIcon', variant: 'success', text: 'Updated' } });
            this.loadItems(); 
            this.cancelEdit();
        } catch (error) {
             this.$toast({ component: ToastificationContent, props: { title: 'Error', icon: 'BellIcon', variant: 'danger', text: 'Failed' } });
        }
    },

    copyToClipboard(text) {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$toast({ component: ToastificationContent, props: { title: 'Copied!', icon: 'CheckIcon', variant: 'success', text: 'Copied' } });
    },

    getWhatsappLink(phone) {
      if (!phone) return '#';
      let formatted = phone.toString().replace(/[^0-9]/g, ''); 
      if (formatted.startsWith('880')) return 'https://wa.me/' + formatted;
      if (formatted.startsWith('01')) return 'https://wa.me/88' + formatted;
      return 'https://wa.me/' + formatted;
    },

    clearFilter() {
      this.searchTerm = ''
      this.rangeDate = null
      this.loadItems()
    },

    async bandActiveCustomer() {
      try {
        await this.$api.get(`api/customer/band-active/${this.modalCustomerId}`)
        this.$toast({ component: ToastificationContent, props: { title: 'Success', icon: 'CheckIcon', variant: 'success', text: "Changed" } })
      } catch (error) {
        this.$toast({ component: ToastificationContent, props: { title: 'Error', icon: 'BellIcon', variant: 'danger', text: "Failed" } })
      }
    },

    async submitFollowupComment() {
      try {
        await this.$api.post(`api/update-follow-up`, { order_id: this.commentModalOrderId, msg: this.followupComment });
        this.$toast({ component: ToastificationContent, props: { title: "Success", icon: "CheckIcon", variant: "success", text: "Updated" } });
        this.hiddenOrderCommentModal();
      } catch (error) {
        this.$toast({ component: ToastificationContent, props: { title: "Error", icon: "BellIcon", variant: "danger", text: error?.response?.data?.message } });
      } 
    },
    
    onViewCustomer(id) {
      this.$router.push({ name: 'admin-customer-history', params: { id } })
    },

    parseVariationAttributes(rawAttributes) {
      if (!rawAttributes) return []

      if (Array.isArray(rawAttributes)) {
        return rawAttributes
          .map((item) => ({
            name: item?.attribute_name || item?.name || '',
            value: item?.attribute_value || item?.value || '',
          }))
          .filter((item) => item.name && item.value)
      }

      if (typeof rawAttributes === 'object') {
        return Object.keys(rawAttributes)
          .map((key) => ({
            name: key,
            value: rawAttributes[key],
          }))
          .filter((item) => item.name && item.value)
      }

      return []
    },

    getOrderItemAttributes(item) {
      const attributeSources = [
        item?.selected_variation?.attributes,
        item?.variation_attributes,
        item?.pivot?.variation_attributes,
        item?.pivot?.attributes,
        item?.pivot?.selected_attributes,
        item?.selected_attributes,
      ]

      for (const rawAttributes of attributeSources) {
        const parsedAttributes = this.parseVariationAttributes(rawAttributes)
        if (parsedAttributes.length) {
          return parsedAttributes
        }
      }

      return []
    },

    getOrderItemSku(item) {
      return item?.variation_sku || item?.selected_variation?.sku || item?.sku || 'N/A'
    },

    // UPDATED STATUS FORMAT TO MATCH YOUR ORDER
    statusFormat(status) {
      const statusMap = {
        pending: 'Pending',
        'pending-1': 'Pending 1',
        'pending-2': 'Pending 2',
        processing: 'Processing',
        hold: 'Hold',
        in_review: 'In Review',
        packing: 'Packing',
        shipping: 'Shipping',
        verified: 'Verified',
        on_the_way: 'On the way',
        returned: 'Return',
        return_received: 'Return Received',
        canceled: 'Cancel',
        delivered: 'Delivery',
        rejected: 'Rejected',
      }
      return statusMap[status] || status
    },

    // UPDATED STATUS VARIANT FOR BETTER UI
    statusVariant(status) {
      const statusColor = {
        pending: 'light-primary',
        'pending-1': 'light-primary',
        'pending-2': 'light-primary',
        processing: 'light-info',
        hold: 'light-warning',
        in_review: 'light-warning',
        packing: 'light-info',
        shipping: 'light-info',
        verified: 'light-success',
        on_the_way: 'light-info',
        returned: 'light-danger',
        return_received: 'light-danger',
        canceled: 'light-danger',
        delivered: 'light-success',
        rejected: 'light-secondary',
      }
      return statusColor[status] || 'light-primary'
    },

    selectionChanged(params) {
      this.isRowChecked = params?.selectedRows.length !== 0
      this.selectedRows = params?.selectedRows
    },
    formatFnTableLastContactDate(value) {
      if (value) return this.$moment(value).format('MMM Do YYYY, h:mm a')
    },
    onView(id) {
      this.$router.push({ name: 'admin-orders-view', params: { id } })
    },

    async getOrderDetails(id) {
      return await this.$api.get(`api/orders/details/${id}`)
    },

    async getFollowUpMsg(id) {
      return await this.$api.get(`api/followUp/msg/${id}?=user`)
    },

    async showModal(id) {
      await this.getOrderDetails(id)
        .then((response) => {
          this.modalOrderId = response.data.data.large_order_id
          this.modalCustomerName = response.data.data.customer.full_name
          this.modalOrderStatus = response.data.data.status
          this.modalCustomerStatus = response.data.data.customer.is_band
          this.modalCustomerPhone = response.data.data.customer.phone
          this.modalCustomerAddress = response.data.data.detail_address
          this.modalProducts = response.data.data.products
          this.modalCustomerId = response.data.data.customer.id
          this.$bvModal.show('modal-order-details')
        })
        .catch((error) => {
          this.$toast({ component: ToastificationContent, props: { title: 'Error', variant: 'danger', text: error?.response?.data?.message } })
        })
    },
    hiddenModal() {
      this.$bvModal.hide('modal-order-details')
      this.resetModal()
    },

    async showOrderCommentModal(id) {
      this.commentModalOrderId = id;
      await this.getFollowUpMsg(id)
        .then((response) => {
          this.followUpMsgs = response?.data?.follow_ups || [];
          this.$bvModal.show('order-comment-modal')
        })
        .catch((error) => {
          this.$toast({ component: ToastificationContent, props: { title: 'Error', variant: 'danger', text: error?.response?.data?.message } })
        })
    },

    hiddenOrderCommentModal() {
      this.followupComment = ''
      this.commentModalOrderId = ''
      this.$bvModal.hide('order-comment-modal')
    },

    resetModal() {
      this.modalOrderId = ''
      this.modalCustomerName = ''
      this.modalOrderStatus = ''
      this.modalCustomerPhone = ''
      this.modalCustomerAddress = ''
      this.modalProducts = []
      this.modalCustomerId = ''
    },
    saveFile(file) {
      const blob = new Blob([file], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.target = '_blank'
      link.click()
    },

    async printSelectedSticker() {
      const orderIds = (this.selectedRows || []).map((item) => item?.id)
      try {
        const response = await this.$api.put('api/print-sticker', { orderIds: orderIds }, { responseType: 'blob' })
        await this.saveFile(response.data)
        this.$toast({ component: ToastificationContent, props: { title: 'Success', variant: 'success', text: 'Sticker Generated' } })
        this.loadItems();
      } catch (error) {
        this.$toast({ component: ToastificationContent, props: { title: 'Error', variant: 'danger', text: 'Failed' } })
      }
    },

    async changeSelectedStatus(status, reason = null) {
      this.$swal({
        title: "Warning!",
        text: "Are You Sure?",
        icon: "warning",
        customClass: { confirmButton: "btn btn-primary", cancelButton: "btn btn-outline-danger ml-1" },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const orderIds = (this.selectedRows || []).map((item) => item?.id)
          try {
            await this.$api.put(`api/order/status/multiple`, { ids: orderIds, status: status, rejection_reason: reason })
            this.loadItems()
            this.$toast({ component: ToastificationContent, props: { title: 'Success', variant: 'success', text: 'Status Changed' } })
          } catch (error) {
            this.$toast({ component: ToastificationContent, props: { title: 'Error', variant: 'danger', text: 'Failed' } })
          }
        }
      });
    },

    onSearch() {
      if (this.delayTimer) clearTimeout(this.delayTimer)
      this.delayTimer = setTimeout(() => { this.loadItems() }, 1000)
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },

    onSortChange(params) {
      this.updateParams({ sort: params })
      this.loadItems()
    },

    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    async getUsers(params) {
      return await this.$api.get('api/orders/all', {
        params: {
          show: params.show,
          page: params.page,
          sort: params.sort,
          q: params.q,
          filterStatus: params.filterStatus,
          rangeDate: params.rangeDate,
        },
      })
    },

    async loadItems() {
      try {
        const [users] = await Promise.all([
          this.getUsers({
            show: this.serverParams.perPage,
            page: this.serverParams.page,
            sort: this.serverParams.sort,
            q: this.searchTerm,
            filterStatus: this.filterStatus,
            rangeDate: this.rangeDate,
          }),
        ])
        this.statusCount = users?.data?.meta?.pagination?.total
        this.totalRecords = users?.data?.meta?.pagination?.total
        this.rows = users?.data?.data
      } catch (error) {
        this.$toast({ component: ToastificationContent, props: { title: 'Error', variant: 'danger', text: 'Load Failed' } })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.image-container { position: relative; display: inline-block; }
.small-image { width: 100px; display: block; }
.large-image {
  position: absolute; top: 0; left: 0; width: 0; height: 0;
  background-size: contain; background-repeat: no-repeat;
  transition: width 0.5s, height 0.5s;
}
.image-container:hover .large-image { width: 500px; height: 500px; z-index: 9999; }
.scrollable { max-height: 500px; overflow-y: auto; overflow-x: hidden; }
</style>